import { render } from "./THeader.vue?vue&type=template&id=4cb49933&scoped=true"
import script from "./THeader.vue?vue&type=script&lang=js"
export * from "./THeader.vue?vue&type=script&lang=js"

import "./THeader.vue?vue&type=style&index=0&id=4cb49933&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb49933"]])

export default __exports__